export enum ROUTES {
    CONFIDENTIALITY = 'confidentiality',
    DOCLIST = 'docList',
    DOCS = 'documents',
    HOME = 'home',
    NOT_FOUND = 'notFound',
    PERSONAL = 'personal',
    TERMS = 'terms',
}
